import http from "infra/http";
import { useQuery } from "react-query";
import { ReservaResponseDetails } from "../typings";

function useReserva(id?: string) {
  return useQuery(
    `/v1/reserva/${id}`,
    async () => {
      const { data } = await http.get<ReservaResponseDetails>(
        `/v1/reserva/${id}`
      );
      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useReserva;
